import React from "react";
import { lightBlueButton } from "constants/colors";
import { Z_INDEX } from "constants/constants";

import styled from "styled-components/macro";

/** (only when horizontal overflow occurs) carousel dots indicating what horizontal pnl chart "page" we're on */
export function DotsOverflowStepper({
  handleStepperClick,
  activeStep,
  numSteps,
}: {
  handleStepperClick: (newActiveStep: number) => void;
  activeStep: number;
  numSteps: number;
}) {
  return (
    <StepperStyles>
      {[...Array(numSteps)].map((_, idx) => (
        <React.Fragment key={idx}>
          <button
            onClick={() => handleStepperClick(idx)}
            className={`stepperDot${activeStep === idx ? " active" : ""}${
              idx === numSteps - 1 ? " last" : ""
            }`}
          >
            <div className="dot" />
          </button>
          <div className="dotsSpacer" />
        </React.Fragment>
      ))}
    </StepperStyles>
  );
}

const SPACER_WIDTH = 15;

const StepperStyles = styled.div`
  position: absolute;
  z-index: ${Z_INDEX.L1};
  top: 0;
  right: -${SPACER_WIDTH}px;
  display: flex;
  .dotsSpacer {
    width: ${SPACER_WIDTH}px;
    height: ${SPACER_WIDTH}px;
  }
  button.stepperDot {
    cursor: pointer;
    border: none;
    box-sizing: border-box;
    background: none;
    padding: 8px; /* increase clickable area */
    margin: -8px;
    opacity: 0.4;
    transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
    &.active {
      opacity: 1;
      pointer-events: none;
    }
    &:hover {
      opacity: 0.7;
      transform: scale(1.1);
    }
    .dot {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background: ${lightBlueButton};
    }
  }
`;
